import React from "react"

import { ORDERED_DAYS } from "../../utils/utils"

const DisplayAvailableTimes = ({ locationOrService, className }) => (
  <div className={className}>
    {ORDERED_DAYS.map((day) => {
      const availableTimesForDay = locationOrService.availableTimes[day]
      if (!availableTimesForDay) return null
      if (availableTimesForDay.enabled === false) return null

      // Check if using new block structure
      if (
        availableTimesForDay.blocks &&
        Array.isArray(availableTimesForDay.blocks) &&
        availableTimesForDay.blocks.length > 0
      ) {
        return (
          <div key={`location-${locationOrService.id}-${day}`}>
            <div className="flex items-center justify-between">
              <span>{day}</span>
              <div className="flex flex-col items-end">
                {availableTimesForDay.blocks.map((block, index) => (
                  <span key={index}>
                    {block.startsAt.replace(/ /g, "").toLowerCase()} - {block.endsAt.replace(/ /g, "").toLowerCase()}
                  </span>
                ))}
              </div>
            </div>
          </div>
        )
      }

      // Legacy format
      if (!availableTimesForDay.startsAt || !availableTimesForDay.endsAt) return null
      return (
        <div key={`location-${locationOrService.id}-${day}`} className="flex items-center justify-between">
          <span>{day}</span>
          <span>
            {availableTimesForDay.startsAt.replace(/ /g, "").toLowerCase()} -{" "}
            {availableTimesForDay.endsAt.replace(/ /g, "").toLowerCase()}
          </span>
        </div>
      )
    })}
  </div>
)

export default DisplayAvailableTimes
